export default __webpack_public_path__ + "static/media/blog06.5405cff2.png";